var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroadMobileSignup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 28,
    viewBox: "0 0 775 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.7 47.85C495.7 75.29 474.96 95.61 447 95.54C419.04 95.47 398.4 75.19 398.46 47.7C398.52 20.56 419.09 0.41002 446.91 0.25002C474.73 0.0900196 495.69 20.48 495.7 47.85ZM488.7 47.85C488.7 24.16 471.2 6.78002 447.31 6.73002C423.07 6.73002 405.37 23.83 405.08 47.66C404.8 71.2 422.75 88.94 446.89 88.98C471.23 89.05 488.71 71.85 488.71 47.88L488.7 47.85Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62 94.78H0V1.25H6.54V43.78H69.37V1.17999H75.92V94.52H69.63V50.52H6.63L6.62 94.78Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.71 7V0C705.2 0.95 722.71 0.110004 739.51 3.27C762.34 7.56 775.97 28.11 774.45 51.17C772.96 73.69 757.03 91.49 734.16 93.68C718.88 95.14 703.36 93.95 687.7 93.95V48.24H694.42V88.78C709.79 88.19 724.82 90.67 739.42 86.51C758.34 81.13 769.22 64.11 767.42 43.51C765.84 24.78 751.8 9.78 732.85 8.02C720.29 6.87 707.59 7.28 694.95 7.02C692.65 6.96 690.37 7 687.71 7Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64 7.00002V0.27002C289.22 0.95002 304.9 -0.00998664 319.93 2.67001C343.04 6.80001 352.52 32.45 339.06 51.06C337.034 53.688 334.6 55.9737 331.85 57.83C329.32 59.63 326.29 60.73 323.11 62.32C330.65 72.93 338.11 83.42 345.89 94.32C341.32 95.32 338.25 95.06 335.54 90.87C330.13 82.49 324.1 74.5 318.19 66.46C317.32 65.28 315.72 63.9 314.44 63.88C303.29 63.67 292.14 63.76 280.24 63.76V94.56H273.83V58.01C284.36 58.01 294.65 58.1 304.94 58.01C309.088 58.0485 313.232 57.7138 317.32 57.01C331.32 54.25 338.03 45.66 337.7 31.29C337.41 18.76 329.36 9.45002 316.04 8.10002C304.98 6.98002 293.77 7.34002 282.63 7.10002C279.82 6.95002 277.01 7.00002 273.64 7.00002Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.37 8.52001C577.93 27.14 569.92 44.77 561.92 62.41C557.807 71.4833 553.697 80.5567 549.59 89.63C547.09 95.17 547.1 95.17 540.35 94.5C540.9 93.06 541.35 91.69 541.92 90.4C555.02 61.9 568.123 33.4 581.23 4.9C582.29 2.59 583.02 0.690009 586.39 0.740009C589.76 0.790009 590.59 2.35001 591.7 4.74001C604.82 33.4067 617.983 62.0733 631.19 90.74C631.73 91.91 632.1 93.15 632.55 94.37C627.71 95.98 625.33 94.37 623.3 89.84C611.94 64.2 600.19 38.73 588.57 13.21C588.07 12.01 587.5 10.83 586.37 8.52001Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6 1.14999V6.66H146.6V1.14999H206.6Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54 49.71V44.33H206.54C206.63 45.98 206.73 47.68 206.84 49.71H146.54Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.6 89.14V94.59H146.54V89.14H206.6Z",
    fill: "#ffffff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 774.56,
    height: 95.54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroadMobileSignup);
export default __webpack_public_path__ + "static/media/HEROAD_mobile_signup.27eca55fec387f09641df8c80895a51c.svg";
export { ForwardRef as ReactComponent };